import React from "react";
// import { Helmet } from "react-helmet-async";

const PageTitle = ({ title }) => {
  return (
    <>
      <title>{title} - Genius car service</title>
    </>
  );
};

export default PageTitle;
